"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _video = babelHelpers.interopRequireDefault(require("./video"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _temp;

var SubmissionVideoCard = (_class = (_temp =
/*#__PURE__*/
function (_VideoCard) {
  babelHelpers.inherits(SubmissionVideoCard, _VideoCard);

  function SubmissionVideoCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubmissionVideoCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionVideoCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "feedbackCount", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SubmissionVideoCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(SubmissionVideoCard.prototype), "renderBottomContent", this).call(this);
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(SubmissionVideoCard.prototype), "renderBottomContent", this).call(this);
      var fb = this.feedbackBadge(this.feedbackCount);

      if (r || fb) {
        if (r) {
          if (!Array.isArray(r)) r = [_react.default.createElement(r.type, Object.assign({
            key: "bottom"
          }, r.props))];
        } else {
          r = [];
        }

        r.unshift(fb);
      }

      return r;
    }
  }]);
  return SubmissionVideoCard;
}(_video.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "feedbackCount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = SubmissionVideoCard;